import { BLAZESWAP_OVERLAY_ABI } from "@/abis/BLAZESWAP_OVERLAY_ABI";
import { BLAZESWAP_ROUTER_ABI } from "@/abis/BLAZESWAP_ROUTER_ABI";
import { LAUNCHPAD_ABI } from "@/abis/LAUNCHPAD_ABI";
import { PULSEX_ROUTER_ABI } from "@/abis/PULSEX_ROUTER_ABI";
import { VESTING_ABI } from "@/abis/VESTING_ABI";
import { Address } from "viem";
import { flare, pulsechain } from "viem/chains";

export enum CHAIN {
  FLARE = 14,
  PULSE = 369,
}

export const availableChains = [CHAIN.FLARE, CHAIN.PULSE];

type ChainConfig = {
  name: string;
  symbol: string;
  address: Address;
  iconUrl: string;
  nativeSymbol: string;
  contracts: {
    pump: string,
    factory: string,
    swapRouter: string
    swapOverlay: string 
    staking: string,
    launchpad: string

  },
  config: any,
  adapters: {
    vestingAbi: any,
    launchpadAbi: any,
    routerAbi: any,
    overlayAbi: any,
    dexSellFunctionName: string,
    dexBuyFunctionName: string,
  },
  explorerTxUrl: (txHash: string) => string
  explorerErc20Url: (address: string) => string
};

const chainConfig: Record<CHAIN, ChainConfig> = {
  [CHAIN.FLARE]: {
    name: "Flare",
    symbol: "wFLR",
    iconUrl: '/images/flare-logo.svg',
    address: "0x1D80c49BbBCd1C0911346656B529DF9E5c2F783d",
    config: flare,
    nativeSymbol: "FLR",
    contracts: {
      factory: "0x140b7F53a0A526d803B604D510A8faE5AdE5D280",
      pump: "0x3550e65FF2A14c3f4aFFdB78CC7b0F6AAa75B7BD",
      swapRouter: "0xe3A1b355ca63abCBC9589334B5e609583C7BAa06",
      swapOverlay: "0x0dDB4253992ab56e13CB30AFedb4A600F6c48Cd8",
      staking: "0xf459263e413Eaa658C631CFdf2B97C69B2454708",
      launchpad : "0x4378E2f3a518fc376d71568980df1C5A7450da8c"
    },
    adapters: {
      overlayAbi: BLAZESWAP_OVERLAY_ABI,
      routerAbi: BLAZESWAP_ROUTER_ABI,
      vestingAbi: VESTING_ABI,
      launchpadAbi: LAUNCHPAD_ABI,      
      dexSellFunctionName: "swapExactTokensForNAT",
      dexBuyFunctionName: "swapExactNATForTokens"
    },
    explorerTxUrl: (txHash: string) => `https://flare-explorer.flare.network/tx/${txHash}`,
    explorerErc20Url: (address: string) => `https://flare-explorer.flare.network/token/${address}`
    
  },
  [CHAIN.PULSE]: {
    name: "Pulse",
    symbol: "wPLS",
    iconUrl: '/images/pulsechain-logo.svg',
    address: "0xA1077a294dDE1B09bB078844df40758a5D0f9a27",
    config: pulsechain,
    nativeSymbol: "PLS",
    contracts: {
      factory: "0x4DBC48a7B02dE6F63398881a7B62df2A65909e3A",
      pump: "0x2BBE2E2B2a3f98E78A6711fAc01E0D295B62cE80",
      swapRouter: "0x165C3410fC91EF562C50559f7d2289fEbed552d9",
      swapOverlay: "0x37D96Ae523afBb384FAcF88df90236D7c84cADa6",
      staking: "0x197091d8E28e80C0ce14111A58C6Be16aa400856",
      launchpad: "0xe6388f1726E82dA115F50a77E0DA6c90489BeaF8",

    },
    adapters: {
        overlayAbi: BLAZESWAP_OVERLAY_ABI,
      vestingAbi: VESTING_ABI,
      launchpadAbi: LAUNCHPAD_ABI,
      routerAbi: PULSEX_ROUTER_ABI,
      dexSellFunctionName: "swapExactTokensForNAT",
      dexBuyFunctionName: "swapExactNATForTokens"
    },
    explorerTxUrl: (txHash: string) => `https://scan.mypinata.cloud/ipfs/bafybeih3olry3is4e4lzm7rus5l3h6zrphcal5a7ayfkhzm5oivjro2cp4/#/tx/${txHash}`,
    explorerErc20Url: (address: string) => `https://scan.mypinata.cloud/ipfs/bafybeih3olry3is4e4lzm7rus5l3h6zrphcal5a7ayfkhzm5oivjro2cp4/#/token/${address}`
  },
};

export const isSupportedChain = (chainId: number): chainId is CHAIN => {
    return chainId in chainConfig;
  };
  
  export const getChainConfig = (chainId: number): ChainConfig => {
    if (!isSupportedChain(chainId)) {
      return chainConfig[CHAIN.FLARE]
    }
  
    return chainConfig[chainId];
  };

  export const getChainCurrency = (chainId: number) => {
    if (!isSupportedChain(chainId)) {
        const { symbol, address } = chainConfig[CHAIN.FLARE]
        return { symbol, address };

    }
  
    const { symbol, address } = chainConfig[chainId];
    return { symbol, address };
  };
  
  export const getChainName = (chainId: number): string => {
    if (!isSupportedChain(chainId)) {
      return chainConfig[CHAIN.FLARE].name
    }
  
    return chainConfig[chainId].name;
  };